import { Stack, Typography } from '@mui/material';
import { CentralAssortmentLogo } from './CentralAssortmentLogo';
import { EditAssortmentMenu } from './AssortmentActionMenus';
import { ExportToExcelButton, ToggleFiltersButton, ToggleFiltersToolbar } from '@retail/components';
import { useAssortmentTFunction } from '@retail/monitoring-assortment/i18n';
import { MonitoringAssortment } from '@retail/monitoring-assortment/types';

interface Props {
  selectedAssortment?: MonitoringAssortment;
  selectedOrgUnitId: number;
  circularLogo: string;
  showFilters: { isOpen: boolean; onToggle: () => void };
  toggleAddItemsModal: () => void;
  toggleEditNameModal: () => void;
  toggleDeleteModal: () => void;
  dataExport: {
    loading: boolean;
    toExcel: () => void;
  };
}

export function MonitoringAssortmentToolbar({
  selectedAssortment,
  selectedOrgUnitId,
  circularLogo,
  showFilters,
  toggleAddItemsModal,
  toggleEditNameModal,
  toggleDeleteModal,
  dataExport,
}: Props) {
  const t = useAssortmentTFunction();

  return (
    <ToggleFiltersToolbar sx={{ mb: 1, justifyContent: 'space-between' }}>
      <Stack direction="row" alignItems="center">
        <Stack flexDirection="row" gap={0.5} alignItems="center">
          <Typography variant="subtitle1">{selectedAssortment?.size}</Typography>
          <Typography variant="body1">
            {selectedAssortment?.size === 1
              ? t('assortment.itemsInAssortmentSingular')
              : t('assortment.itemsInAssortmentPlural')}
          </Typography>
        </Stack>
        {selectedOrgUnitId !== selectedAssortment?.owner?.id && selectedAssortment && (
          <CentralAssortmentLogo selectedBrandLogo={circularLogo} />
        )}
      </Stack>

      {selectedAssortment && (
        <Stack gap={1.5} flexDirection="row" alignItems="center">
          <ExportToExcelButton onClick={dataExport.toExcel} loading={dataExport.loading} />

          <EditAssortmentMenu
            onAddClick={toggleAddItemsModal}
            onEditNameClick={toggleEditNameModal}
            onDeleteClick={toggleDeleteModal}
          />
          <ToggleFiltersButton
            showFilters={showFilters.isOpen}
            toggleFilters={showFilters.onToggle}
            buttonHeight={50}
            sx={{ mb: -1.1 }}
          />
        </Stack>
      )}
    </ToggleFiltersToolbar>
  );
}
